import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { Card, CardContent, Typography } from '@mui/material';
import { ReactComponent as ZTTextLogo } from './icons/ZeroTime_TextLogo.svg';

const useStyles = makeStyles((theme) => ({
  ztLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    width: theme.spacing(52),
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(2)
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    background: '#f5f5f5'
  },
  message: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(4)
  },
  textBold: {
    fontWeight: theme.typography.fontWeightBold
  }
}));

const CollectorAccessDeniedPage = (): ReactElement => {
  const classes = useStyles();
  return (
    <div
      data-testid="collector-access_denied-page"
      className={classes.container}
    >
      <div
        className={classes.ztLogo}
        data-testid="collector-access_denied-ztLogo"
      >
        <ZTTextLogo />
      </div>

      <br />
      <Card className={classes.card} data-testid="collector-access_denied-card">
        <CardContent className={classes.message}>
          <Typography variant="h4">
            <FormattedMessage id="collectorError.accessDeniedMessage1" />
          </Typography>
          <br />
          <Typography
            data-testid="collector-accessDenied-message2"
            variant="body1"
          >
            <FormattedMessage id="collectorError.accessDeniedMessage2" />
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default CollectorAccessDeniedPage;
